import { render, staticRenderFns } from "./ModifyUncappedPackageModal.vue?vue&type=template&id=b0e49144&"
import script from "./ModifyUncappedPackageModal.vue?vue&type=script&lang=js&"
export * from "./ModifyUncappedPackageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports